// extracted by mini-css-extract-plugin
module.exports = {"scanFilter":"ScanHistoryFilter_scanFilter__3I_ck"};